/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD

/**
 * @module Version
 */

export const PACKAGE_VERSION = "2.2.1";
